import { PackageContentProps } from '../../../models/slides/PackageSlide';

/**
 * PackageDiscount component
 * this component is responsible for rendering the package discount
 * @param calculatedDiscount - the calculated discount
 * @returns PackageDiscount component
 */

export const PackageDiscount = ({ calculatedDiscount }: PackageContentProps) => {
  if (!calculatedDiscount) return null;
  return (
    <div className='min-[350px]:hidden sm:flex items-center justify-center w-min px-2 sm:h-6 min-[1200px]:h-8 py-2 text-center rounded-sm bg-[#C01010] text-white sm:mb-3 min-[1200px]:mb-4'>
      <p className='font-body font-bold'>{-calculatedDiscount}%</p>
    </div>
  );
};
